var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"partners"}},[_c('div',{staticClass:"t"},[_vm._v("PARTNERS")]),_c('img',{attrs:{"src":require('@/assets/2024/sponsors.png')}})])}
var staticRenderFns = []

export { render, staticRenderFns }